import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

import { type CreateLabelParams, createCtaLabel } from './helpers';

const { ACCOUNT } = ANALYTICS_CATEGORIES;
const { CTA_CLICKED } = SNOWPLOW_EVENTS;

interface TriggerSellerMessagingSendMessagesButtonClickedEventParams {
	buttonLabel: string;
	response: CreateLabelParams;
	success: boolean;
	url: string;
}

export const triggerSellerMessagingSendMessagesButtonClickedEvent = ({
	buttonLabel,
	response: { failedToUpdateEnquiries, updatedEnquiryIds },
	success,
	url,
}: TriggerSellerMessagingSendMessagesButtonClickedEventParams): void => {
	const label = createCtaLabel({ failedToUpdateEnquiries, updatedEnquiryIds });

	const eventPayload = getSnowplowEventPayload({
		category: ACCOUNT.SELLER_MESSAGING,
		customData: { button_label: buttonLabel, label, success, url },
		name: 'dlr_seller_messaging_send_messages_button_clicked',
		schemaName: CTA_CLICKED.SCHEMA,
		version: CTA_CLICKED.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
